module.exports = __webpack_public_path__ + "img/health_care.5af7c347.png";